// extracted by mini-css-extract-plugin
module.exports = {"header":"HtmlHeader_header__h_59f","picture":"HtmlHeader_picture__J0-9L"};